import auth from '@/router/auth'
import Login from '@/components/account/Login'
import Show from '@/components/account/Show'
import ResetPass from '@/components/account/ResetPass'

export default [
  {
    path: '/login',
    name: 'account-login',
    component: Login
  },
  {
    path: '/account/show',
    name: 'account-show',
    component: Show,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/account/reset-pass',
    name: 'account-reset-pass',
    component: ResetPass,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/account/router.js